
<body>
<!-- <ng-http-loader [filteredUrlPatterns]="['offset']"></ng-http-loader> -->
<!-- <app-header *ngIf="showHead"></app-header> -->


<router-outlet (activate)="onActivate($event)"></router-outlet>
<!-- <router-outlet></router-outlet> -->

<!-- <app-footer *ngIf="showFoot"></app-footer> -->

<!-- <div *ngIf="isHomePage" class="homepage-badge">
  <a href="https://appsumo.com/products/crafttor?utm_source=partner-badge&utm_medium=referral&utm_campaign=partner-209324"
     target="_blank" rel="noopener">
    <img src="https://appsumo2ppnuxt.b-cdn.net/img/as-badge-featured.2433f63.png"
         alt="AppSumo badge">
  </a>
</div> -->

</body>

<!-- </html> -->
